var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShoppingBag = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12 1.5a3.43 3.43 0 0 1 3.428 3.429V6.5h1.834a2.57 2.57 0 0 1 2.569 2.45l.612 10.856a2.57 2.57 0 0 1-2.446 2.691l-.122.003H6.125a2.57 2.57 0 0 1-2.571-2.571l.003-.123.612-10.857A2.57 2.57 0 0 1 6.738 6.5H8.57V4.929A3.43 3.43 0 0 1 12 1.5m5.262 6.714h-1.834v2.572a.857.857 0 1 1-1.714 0V8.214h-3.429v2.572a.857.857 0 0 1-1.714 0V8.214H6.738a.857.857 0 0 0-.857.817l-.613 10.898c0 .473.384.857.857.857h11.75l.04-.001a.857.857 0 0 0 .816-.897L18.118 9.03a.857.857 0 0 0-.856-.817M10.286 4.93a1.714 1.714 0 1 1 3.428 0V6.5h-3.429z",
  clipRule: "evenodd"
})));
export default SvgShoppingBag;